export const LETTER = {
  GUARANTEE: 'GUARANTEE',
  CLEAR: 'CLEAR',
  CLEAR_API:'CLEAR_API',
}
